import { render, staticRenderFns } from "./Tour.vue?vue&type=template&id=2aac8bbe"
import script from "./Tour.vue?vue&type=script&lang=ts"
export * from "./Tour.vue?vue&type=script&lang=ts"
import style0 from "./Tour.vue?vue&type=style&index=0&id=2aac8bbe&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports